import axios from "./AxiosInstance"

const create = (data) => axios.post("api/reminders", { ...data })

const getTypes = () => axios.get("api/reminderTypes")

const getList = (patientId) => {
    console.log(patientId)
    return axios.get(`api/reminders?patientId=${patientId}`)
}

const put = (id, data) => axios.put(`api/reminders/${id}`, { ...data })

const deleteById = (id) => axios.delete(`api/reminders/${id}`)

const getRecurrences = () => axios.get("api/recurrences")

export const ReminderService = {
    create,
    getList,
    getTypes,
    put,
    deleteById,
    getRecurrences
}
